import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Car, Calculator, Newspaper } from 'lucide-react';

const SectionToggle = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const tabs = [
    { name: 'The Garage', path: '/', icon: Car },
    { name: 'Costs & Savings', path: '/costs', icon: Calculator },
    { name: 'EV News', path: '/news', icon: Newspaper },
  ];

  return (
    <div className="flex justify-center w-full mb-8">
      <div className="bg-slate-100 p-1.5 rounded-full flex flex-wrap sm:flex-nowrap gap-1 border border-slate-200 shadow-inner max-w-2xl w-full sm:w-auto">
        {tabs.map((tab) => {
          // Keep the Garage active even if viewing a specific deal
          const isActive = currentPath === tab.path || (tab.path === '/' && currentPath.startsWith('/deal/'));
          const Icon = tab.icon;
          
          return (
            <Link
              key={tab.name}
              to={tab.path}
              className={`flex flex-1 sm:flex-none items-center justify-center gap-2 px-6 py-2.5 rounded-full text-sm font-bold transition-all duration-200 ${
                isActive 
                  ? 'bg-white text-blue-600 shadow-sm ring-1 ring-slate-200/50' 
                  : 'text-slate-500 hover:text-slate-800 hover:bg-slate-200/50'
              }`}
            >
              <Icon className="w-4 h-4" />
              <span className="hidden sm:inline">{tab.name}</span>
              <span className="sm:hidden">{tab.name.split(' ')[0]}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default SectionToggle;